export {
  ATHENA_AUTHENTICATOR_METADATA_CATALOG,
  lookupAuthenticatorMetadata,
} from "./catalog.ts";
export { resolvePasskeyAuthenticatorDisplay } from "./resolve.ts";
export type {
  AthenaAuthenticatorMetadata,
  AthenaPasskeyDiscoverability,
  AthenaPasskeyDisplayName,
  AthenaPasskeyDisplayNameInput,
} from "./types.ts";
